import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTopBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-top-bottom, sort 1, switch vertical"><path d="M3.25 7.75L7.25 3.75L11.25 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 16.25L16.75 20.25L20.75 16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.25 5V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.75 3.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowTopBottom;
